export const config = {
  confetti_01: {
    alpha: {
      start: 1,
      end: 0.3,
    },
    scale: {
      start: 1,
      end: 1,
      minimumScaleMultiplier: 1,
    },
    color: {
      start: '#ffffff',
      end: '#ffffff',
    },
    speed: {
      start: 1000,
      end: 50,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 0,
    },
    maxSpeed: 0,
    startRotation: {
      min: 70,
      max: 100,
    },
    noRotation: false,
    rotationSpeed: {
      min: 0,
      max: 0,
    },
    lifetime: {
      min: 0.2,
      max: 0,
    },
    blendMode: 'normal',
    frequency: 0.001,
    emitterLifetime: -1,
    maxParticles: 70,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: false,
    spawnType: 'rect',
    spawnRect: {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
    },
  },
  confetti_02: {
    alpha: {
      start: 1,
      end: 0.3,
    },
    scale: {
      start: 1,
      end: 1,
      minimumScaleMultiplier: 1,
    },
    color: {
      start: '#ffffff',
      end: '#ffffff',
    },
    speed: {
      start: 1000,
      end: 50,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 0,
    },
    maxSpeed: 0,
    startRotation: {
      min: 70,
      max: 100,
    },
    noRotation: false,
    rotationSpeed: {
      min: 0,
      max: 0,
    },
    lifetime: {
      min: 0.2,
      max: 0,
    },
    blendMode: 'normal',
    frequency: 0.001,
    emitterLifetime: -1,
    maxParticles: 70,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: false,
    spawnType: 'rect',
    spawnRect: {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
    },
  },
  confetti_03: {
    alpha: {
      start: 1,
      end: 0.3,
    },
    scale: {
      start: 1,
      end: 1,
      minimumScaleMultiplier: 1,
    },
    color: {
      start: '#ffffff',
      end: '#ffffff',
    },
    speed: {
      start: 1000,
      end: 50,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 0,
    },
    maxSpeed: 0,
    startRotation: {
      min: 70,
      max: 100,
    },
    noRotation: false,
    rotationSpeed: {
      min: 0,
      max: 0,
    },
    lifetime: {
      min: 0.2,
      max: 0,
    },
    blendMode: 'normal',
    frequency: 0.001,
    emitterLifetime: -1,
    maxParticles: 70,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: false,
    spawnType: 'rect',
    spawnRect: {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
    },
  },
  confetti_04: {
    alpha: {
      start: 1,
      end: 0.3,
    },
    scale: {
      start: 1,
      end: 1,
      minimumScaleMultiplier: 1,
    },
    color: {
      start: '#ffffff',
      end: '#ffffff',
    },
    speed: {
      start: 1000,
      end: 50,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 0,
    },
    maxSpeed: 0,
    startRotation: {
      min: 70,
      max: 100,
    },
    noRotation: false,
    rotationSpeed: {
      min: 0,
      max: 0,
    },
    lifetime: {
      min: 0.2,
      max: 0,
    },
    blendMode: 'normal',
    frequency: 0.001,
    emitterLifetime: -1,
    maxParticles: 70,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: false,
    spawnType: 'rect',
    spawnRect: {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
    },
  },
  dot_01: {
    alpha: {
      start: 1,
      end: 0.3,
    },
    scale: {
      start: 2,
      end: 3,
      minimumScaleMultiplier: 1,
    },
    color: {
      start: '#ffffff',
      end: '#ffffff',
    },
    speed: {
      start: 1000,
      end: 50,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 0,
    },
    maxSpeed: 0,
    startRotation: {
      min: 70,
      max: 100,
    },
    noRotation: false,
    rotationSpeed: {
      min: 0,
      max: 0,
    },
    lifetime: {
      min: 0.2,
      max: 0,
    },
    blendMode: 'normal',
    frequency: 0.001,
    emitterLifetime: -1,
    maxParticles: 500,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: false,
    spawnType: 'rect',
    spawnRect: {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
    },
  },
}
